module.exports = __webpack_public_path__ + "img/google-sheet.20e229fd.svg";